import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcChargingStationReducer (state: RootState) {
  return state.acChargingStationReducer
}